  <mat-form-field [subscriptSizing]="'dynamic'" class="fuse-mat-dense w-full">
    <mat-label>{{label}}</mat-label>
    <mat-chip-grid #chipGrid>
      <mat-chip-row *ngFor="let member of membersFC.value" (removed)="removeMember(member.id)">
        <img *ngIf="member?.pictureUrl" matChipAvatar [src]="member?.pictureUrl" alt="Photo" />
        {{member.displayName}}
        <mat-icon *ngIf="!member.isI" class="icon-size-5" matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input [placeholder]="'Search...'" [matChipInputFor]="chipGrid" [matAutocomplete]="auto2"
        [formControl]="membersSearchFC" #membersSearchInput>
      <mat-autocomplete autoActiveFirstOption #auto2="matAutocomplete" (optionSelected)="selectMember($event)">
        <mat-option *ngFor="let user of members$ | async" [value]="user">
          <div class="flex gap-2 items-center">
            <div *ngIf="user?.pictureUrl" class="w-8 h-8 overflow-hidden rounded-full">
              <img class="h-full w-full object-contain" [src]="user?.pictureUrl">
            </div>
            <span>{{user.displayName}}</span>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-chip-grid>
  </mat-form-field>